import React, { RefObject, useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import ContactForm from './ContactForm'
import SectionWithTag from '../../../components/SectionWithTag'
import FadeIn from '../../../components/Animation/FadeIn'

interface GetInTouchProps {
  scrollRef: RefObject<HTMLDivElement>
}

const GetInTouch = ({ scrollRef }: GetInTouchProps) => {
    const ref = useRef<HTMLDivElement>(null)

    return (
        <div className='py-12 md:py-30 relative 3xl:max-w-screen-2xl mx-auto'>
            <SectionWithTag tag={{ id: 'page.contactUs.description' }}>
                <FadeIn>
                    <div className='flex xl:flex-row flex-col items-center pt-9 xl:pt-16 xl:pt-0 gap-y-8 xl:gap-y-0 relative'>
                        <div className='max-w-[460px]' ref={ref}>
                            <FormattedMessage id='page.contactUs.contactForm.title' tagName='h2' />
                            <div className='xl:max-w-[410px] pt-6 flex flex-col gap-y-6'>
                                <FormattedMessage id='page.contactUs.contactForm.description' tagName='p' />
                                <FormattedMessage id='page.contactUs.contactForm.contact.description' tagName='p' />
                            </div>
                        </div>
                        <ContactForm scrollRef={scrollRef} />
                    </div>
                </FadeIn>
            </SectionWithTag>
        </div>
    )
}

export default GetInTouch
